import { useEffect } from 'react';

import { useFormMutators } from './useFormMutators';

/**
 * This manually removes the opportunity from the form state when the opportunity is unmounted.
 * This is because we don't use the "destroyOnUnregister" form option.
 * We change the stake input key to revalidate the stake, which causes it to be re-mounted.
 * Re-mounting the stake input unregisters the field with the "destroyOnUnregister" form option.
 */
export const useRemoveOpportunityFieldOnUnmount = (opportunityId: string) => {
  const mutators = useFormMutators();

  useEffect(
    () => () => {
      mutators.removeField(opportunityId);
    },
    [mutators, opportunityId]
  );
};
